import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import { Radio, RadioGroup } from "@mui/material";
import { TextField, Typography, Divider } from "@mui/material";
import { FormControlLabel, FormControl, FormLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import DialogTitle from "@mui/material/DialogTitle";
import { displayCapnr } from "./helperFunctions";
import EventContext from "../store/event-context";
import ColorSelection from "./colorSelection";
import { useState, useContext } from "react";

const ParticipantCapnr = ({ name, capnr, setCapnr, close, setIsWaiting }) => {

  const eventctx = useContext(EventContext);
  const haveColor = eventctx.event.colors.length > 1;

  const [selectionId, setselectionId] = useState(0);
  const [enteredCapnr, setEnteredCapnr] = useState("");
  const [color, setColor] = useState(eventctx.event.colors[0]);
  const [canReuse, setCanReuse] = useState(false);

  const handleClose = () => {
    setIsWaiting(true);
    console.log("handleClose - selectionId: ", selectionId, selectionId === "1");
    console.log("handleClose - enteredCapnr: ", enteredCapnr);
    setCapnr(selectionId === "1" ? `${color}:${enteredCapnr}` : "", canReuse);
    //setCapnr(selectionId === 1 ? color + ":" + enteredCapnr : "", canReuse);
  };

  const handleCancel = () => {
    close();
  };

  const handleRadioChange = (event) => {
    console.log("handleRadioChange - event.target.value: ", event.target.value);
    setselectionId(event.target.value);       // 0 = First available / 1 = Own number
    setCanReuse((event.target.value > 0));    // When owner number, the current cap can probably be reused
  };

  const handleReuseChange = (event) => {
    setCanReuse(event.target.checked);
  };

  //useEffect (() => {
  //  if (selectionId) {
  //    setCanReuse(true)
  //  } else {
  //    setCanReuse(false)
  //  }
  //}, [setCanReuse, selectionId])

  return (
    <div>
      <Dialog
        open={true}
        maxWidth='xs' 
        fullWidth
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Ander badmutsnummer toewijzen aan: {name}</DialogTitle>
        <DialogContent>
        <Stack id="newCapnrStack" direction='column' spacing={1}>
          <Typography id="CurrentCapNr" sx={{ marginBottom: '10px', paddingLeft: '10px', fontWeight: 'bold' }}>{'Huidig capnr:  ' + displayCapnr(capnr, eventctx.event.colors)}</Typography>
          <FormControl sx={{ paddingLeft: '20px'}} >
            <FormLabel id="NewCapNrRadioGroup-label" sx={{marginBottom: '10px', color: "black" }} >Nieuwe nummer?</FormLabel>
            <Divider sx={{ marginBottom: haveColor? '12px': '0px'}} />
            {haveColor && <ColorSelection color={color} setColor={setColor} fieldWidth='180'/>}
            <RadioGroup
              aria-labelledby="NewCapNrRadioGroup-label"
              value={selectionId}
              onChange={handleRadioChange}
              name="radio-buttons-group"
              >
              <FormControlLabel value={0} control={<Radio />} label="Eerst beschikbaar capnr. gebruiken" />
              <FormControlLabel value={1} control={<Radio />} label="Zelf specifiek nummer invullen" />
            </RadioGroup>
          </FormControl>
          {(selectionId > 0) && <TextField
                autoFocus
                required
                id="Capnr-textfield"
                margin='none'
                size='small'
                label="capnr"
                type="number"
                InputProps={{ style: { marginLeft: '30px', backgroundColor: 'white' } }}
                InputLabelProps={{ style: { marginLeft: '30px' } }}
                value={enteredCapnr}
                onChange={(e) => setEnteredCapnr(e.target.value)}
                sx={{width: '50%'}}
          />}
          <FormControlLabel sx={{ paddingTop: '20px'}}
            control={
              <Checkbox
                checked={canReuse}
                onChange={handleReuseChange}
                name="checked"
                color="primary"
              />
            }
            label="Oude capnr. weer beschikbaar maken?"
          />
        </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary" variant="outlined" sx={{ width: '30%', textTransform: 'capitalize' }}>
            Annuleren
          </Button>
          <Button onClick={handleClose} color="primary" variant="outlined" sx={{ width: '30%', textTransform: 'capitalize' }}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ParticipantCapnr;
